export function ajaxUploadImg(fd: FormData): XMLHttpRequest {
  const xhr = new XMLHttpRequest();
  xhr.open("POST", `${process.env.REACT_APP_PUBLIC_PATH}/UploadImg.ashx`);
  xhr.send(fd);
  return xhr;
}

export function ajaxReadBarcode(fd: FormData): XMLHttpRequest {
  const xhr = new XMLHttpRequest();
  xhr.open("POST", `${process.env.REACT_APP_PUBLIC_PATH}/ReadBarcode.ashx`);
  xhr.send(fd);
  return xhr;
}

export function ajaxCancelRequest(fd: FormData): XMLHttpRequest {
  const xhr = new XMLHttpRequest();
  xhr.open("POST", `${process.env.REACT_APP_PUBLIC_PATH}/CancelRequest.ashx`);
  xhr.send(fd);
  return xhr;
}

export async function ajaxConvertTemplate(fd: FormData): Promise<string> {
  return await new Promise((rs, rj) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${process.env.REACT_APP_PUBLIC_PATH}/ConvertTemplate.ashx`);
    xhr.send(fd);
    xhr.onload = () => {
      rs(JSON.parse(xhr.response).result);
    }
    xhr.onerror = rj;
  })
}

export async function ajaxGetVersion(): Promise<{ success: boolean, version?: string }> {
  return await new Promise((rs, rj) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${process.env.REACT_APP_PUBLIC_PATH}/GetVersion.ashx`);
    xhr.send();
    xhr.onloadend = async () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        rj({ success: false });
      } else {
        rs(JSON.parse(xhr.response));
      }
    };
    xhr.onerror = () => {
      rj({ success: false });
    };
  })
}